<template>
  <v-container class="mobile_success_form section_form_middle padding_view" :style="$vuetify.breakpoint.height < 450 ? {'margin-top': '20px'} : {}">
    <div class="pt-10">
      <div class="mobileview">
        <img src="../assets/ui/circle.svg" alt="" class="feature-img" />
        <div class="text_bold" style="padding: 10px">
          {{ $t("newUi.createSuccess.formSuccess") }}
        </div>
        <p style="font-size: 12px">
          {{ $t("newUi.createSuccess.addProducts") }}
        </p>
      </div>

      <div class="row desktopView" style="margin-left: 0px">
        <img
          src="../assets/ui/circle.svg"
          alt=""
          style="width: 40px; margin: 15px; margin-right: 30px"
          class="feature-img"
        />
        <span class="pt-4">
          <span class="text_bold tb">{{
            $t("newUi.createSuccess.formSuccess")
          }}</span>
          <p style="font-size: 12px; margin: 0px; padding: 0px">
            {{ $t("newUi.createSuccess.addProducts") }}
          </p>
        </span>
      </div>

      <div class="bottom_tab mobileview">
        <div class="text-center">
          <v-btn
            @click="add_category_open"
            class="button_padding"
            color="#8AB26D"
            >{{ $t("newUi.adminViewform.addCat") }}</v-btn
          >
          <v-btn @click="submit" class="button_padding" color="#8AB26D">
            {{ $t("newUi.adminViewform.addPro") }}
          </v-btn>
        </div>
        <div
          @click="cancel"
          class="text-decoration-underline text_color"
          color="success"
          style="padding: 10px; margin: 10px"
        >
          {{ $t("newUi.createSuccess.skip") }}
        </div>
      </div>
      <div class="mt-10 desktopView">
        <div style="padding-top: 20%">
          <v-btn
            @click="add_category_desktop"
            class="button_padding"
            color="#8AB26D"
            >{{ $t("newUi.adminViewform.addCat") }}</v-btn
          >
          <v-btn
            @click="add_product_desktop"
            class="button_padding"
            color="#8AB26D"
          >
            {{ $t("newUi.adminViewform.addPro") }}
          </v-btn>
          <span
            @click="cancel"
            class="text-decoration-underline cursor-pointer"
            style="padding: 10px; margin: 10px"
          >
            {{ $t("newUi.createSuccess.skip") }}
          </span>
        </div>
      </div>
      <v-bottom-sheet v-model="sheet">
        <v-card class="elevation-0 bottom_modal">
            <v-card-text class="text-center "  style="overflow-y: scroll;" :class="{sheet_height: $vuetify.breakpoint.height < 450, sheet_normal_height: $vuetify.breakpoint.height > 450}">
          <AddProducts :payload="payload"></AddProducts>
            </v-card-text>
          </v-card>
      </v-bottom-sheet>
      <v-bottom-sheet v-model="add_category">
         <v-card class="elevation-0 bottom_modal">
            <v-card-text class="text-center "  style="overflow-y: scroll;" :class="{sheet_height: $vuetify.breakpoint.height < 450}">
          <AddCategory :payload="payload"></AddCategory>
            <div :class="{padding_category: $vuetify.breakpoint.height < 450}"></div>
            </v-card-text>
          </v-card>
      </v-bottom-sheet>
    </div>
  </v-container>
</template>
<script>
import router from "../router/router";
import { saveFile, setLocale } from "../services/firebase";
import { saveMasterData } from "../services/firebase";
import store from "../store/store";
import i18n from "../i18n";
import { saveImage } from "../services/firebase";
import AddProducts from "@/components/AddProducts.vue";
import AddCategory from "./AddCategory.vue";
export default {
  props: ["payload"],
  components: {
    AddProducts,
    AddCategory,
  },
  data() {
    return {
      sheet: false,
      add_category: false,
      name: "",
      description: "",
      addproduct_category: "",
      addproduct_desc: "",
      addproduct_name: "",
      addproduct_price: 0,
      addproduct_image: "",
      cropped: null,
      cropDialog: false,
      croppieElm: null,
    };
  },
  mounted() {
    setLocale();
  },
  computed: {
    type: function () {
      if (this.payload.type == "Ordering form") {
        return i18n.t("common.typeOrderForm");
      } else {
        return i18n.t("common.typeCatelogue");
      }
    },
    category_name: function () {
      let categories = [];
      let objects = this.payload.catalogue.filter((o) => o.type == "category");
      objects.forEach((item) => {
        categories.push(item.name);
      });
      return categories;
    },
    isEditable: function () {
      if (this.$route.name === "viewform") return false;
      return true;
    },
  },
  methods: {
    add_catag: function (name, description) {
      var p = this.$store.state.currentForm.catalogue.maxlength;
      if (!p) {
        p = 1;
        this.$store.dispatch("setMaxLength", 1);
      } else {
        var maxlength = this.$store.state.currentForm.catalogue.maxlength + 1;
        p = maxlength;
        this.$store.dispatch("setMaxLength", maxlength);
      }
      this.$store.state.currentForm.catalogue.push({
        pos: p,
        type: "category",
        name: name,
        description: description,
      });
      // console.log(this.$store.state.currentForm.catalogue)
    },
    additem: function (name, description, price, category, image) {
      var p = this.$store.state.currentForm.catalogue.maxlength;
      if (!p) {
        p = 1;
        this.$store.dispatch("setMaxLength", 1);
      } else {
        var maxlength = this.$store.state.currentForm.catalogue.maxlength + 1;
        p = maxlength;
        this.$store.dispatch("setMaxLength", maxlength);
      }
      this.$store.state.currentForm.catalogue.push({
        pos: p,
        type: "item",
        name: name,
        desc: description,
        imageurl: image,
        price: price,
        qtty: 0,
        category: category,
      });
      // console.log(this.$store.state.currentForm);
    },
    add_product_more(name, description, price, category, image) {
      if (name != "" && price != 0) {
        this.additem(name, description, price, category, image);
        this.saveCurrentForm();
        this.set_product_item_null();
        this.sheet = true;
      }
    },
    add_product_submit(name, description, price, category, image) {
      if (name != "" && price != 0) {
        this.additem(name, description, price, category, image);
        this.saveCurrentForm();
        this.sheet = false;
        router.push("/admin/viewform/" + this.$store.state.currentForm.pos);
      }
    },
    add_product_desktop() {
      router.push({
        name: "addItems",
        params: {
          formno: this.$store.state.currentForm.pos,
          add_type: "Product",
        },
      });
    },
    add_category_desktop() {
      router.push({
        name: "addItems",
        params: {
          formno: this.$store.state.currentForm.pos,
          add_type: "Category",
        },
      });
    },
    set_product_item_null() {
      this.addproduct_desc = "";
      this.addproduct_image = "";
      this.addproduct_name = "";
      this.addproduct_price = "";
    },
    set_category_item_null() {
      this.name = "";
      this.description = "";
    },
    submit: function () {
      this.sheet = true;
    },
    add_category_open: function () {
      this.add_category = true;
    },
    add_category_submit: function (name, description) {
      if (name != "") {
        this.add_catag(name, description);
        this.saveCurrentForm();
        this.add_category = false;
        router.push("/admin/viewform/" + this.$store.state.currentFormPos);
      }
    },
    cancel: function () {
      router.push("/admin/viewform/" + this.$store.state.currentFormPos);
    },
    add_category_more: function (name, description) {
      if (name != "") {
        this.add_catag(name, description);
        this.saveCurrentForm();
        this.set_category_item_null();
        this.add_category = true;
      }
    },
    saveCurrentForm: function () {
      var shopname = this.$store.state.currentForm.shopname;
      var phone = this.$store.state.currentForm.phone;

      // console.log(this.$store.state);
      if (shopname == null || !shopname || shopname == "") {
        alert(i18n.t("alertText.validateNameAlert", { type: this.type }));
      } else if (phone.length != 13) {
        alert(i18n.t("alertText.validatePhoneAlert"));
      } else {
        this.$store.dispatch("setOverlay", true);
        saveFile(
          this.$store.state.profile.uid,
          this.$store.state.currentFormPos,
          JSON.stringify(this.$store.state.currentForm),
          function (error) {
            if (error) {
              //TODO skeleton data
              alert(i18n.t("alertText.saveFailed"));
              store.dispatch("setOverlay", false);
            } else {
              alert(i18n.t("alertText.uploadText"));
              store.dispatch("setOverlay", false);
            }
          }
        );
        saveMasterData(function (err) {
          console.log(err);
        }, this.$store.state);
      }
    },
    crop() {
      let options = {
        type: "base64",
        size: "viewport",
        format: "jpeg",
        circle: false,
      };
      let elethis = this;
      // console.log(elethis);
      var uid = this.$store.state.profile.uid;
      this.$refs.croppieRef.result(options).then(function (output) {
        elethis.cropped = output;
        saveImage(uid, new Date().getTime(), output, function (error, newurl) {
          if (error) {
            alert(i18n.t("alertText.uploadFail"));
          } else elethis.addproduct_image = newurl;
        });
      });
    },
    crop1() {
      // Here we are getting the result via callback function
      // and set the result to this.cropped which is being
      // used to display the result above.
      let options = {
        format: "jpeg",
        circle: true,
      };
      this.$refs.croppieRef.result(options, (output) => {
        this.cropped = output;
      });
    },
    result(output) {
      this.cropped = output;
    },
    update(val) {
      console.log(val);
    },
    rotate(rotationAngle) {
      // Rotates the image
      this.$refs.croppieRef.rotate(rotationAngle);
    },
    uploading: function () {
      const input = document.createElement("input");
      const elethis = this;
      input.setAttribute("type", "file");
      input.addEventListener("change", function () {
        // console.log(e);
        elethis.cropDialog = true;
        setTimeout(() => {
          // console.log(elethis.$refs);
          elethis.$refs.croppieRef.bind({
            url: window.URL.createObjectURL(input.files[0]),
            zoom: 0.8,
          });
        }, 200);
      });
      input.click();
      return false; // avoiding navigation
    },
  },
};
</script>
<style lang="scss">
.text_color {
  color: #8ab26d;
  font-weight: bold;
}
.button_padding {
  margin-right: 10px;
  padding: 10px;
  color: white !important;
  text-align: center;
  font-weight: bold;
  font-size: 12px;
  letter-spacing: 0px;
  text-transform: none;
  cursor: pointer;
}
.bottom_tab {
  width: 100%;
  text-align: center;
  left: 0;
  right: 0;
  margin-top: 130px;
}
.cr-slider-wrap {
  display: none;
}
.bottom_modal {
  border-top-right-radius: 20px  !important;
  border-top-left-radius: 20px !important;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}

@media (min-width: 320px) and (max-width: 960px)  {
  .mobile_success_form {
    text-align: center;
  }
  .section_form_middle {
    display: flex;
    margin-top: 35%;
    justify-content: center;
  }
  .pt-10 {
    padding-top: 10%;
  }
  .section_middle {
    position: fixed;
    bottom: 5%;
  }
  .sheet_height {
  height: 300px;
}
.sheet_normal_height {
  height: 90%;
}
.padding_category {
  height: 100px;
}
}
@media (min-width: 960px) {
  .section_form_middle {
    display: flex;
    margin-top: 40px;
  }
  .pt-10 {
    padding-top: 5%;
  }
  .tb {
    text-align: center;
    font-weight: bold;
    letter-spacing: 0px;
    color: #666666;
    opacity: 1;
  }
}
</style>
